<template>
    <div>
        <box-dropdown
            :is-dropdown-left-zero="false"
            :no-closing-el-selector="noClosingElSelector"
            :is-open="isOpen"
            v-on:update:is-open="updateIsOpen"
            :right="-100"
        >
            <template slot="selected-item">
                <div class="selected-items">
                    <span v-if="selectedAddOns.length === 0">{{ $t('addOnsSelect.placeholder') }}</span>
                    <div class="selected-item" v-for="(selectedAddOn, index) in selectedAddOns">
                        <span>{{ index + 1 + '.'}}&nbsp</span>
                        <span class="name">{{ getAddOn(selectedAddOn.add_on_id).name }}</span>
                        <span>&nbsp{{ 'x' + selectedAddOn.qty }}&nbsp</span>
                        <span>{{ '+' + priceToString(getAddOn(selectedAddOn.add_on_id).price * selectedAddOn.qty) }}</span>
                        <i
                                class="fas fa-times remove-btn"
                                @click.stop="() => removeAddOn(selectedAddOn.add_on_id)"
                        ></i>
                    </div>
                </div>
            </template>
            <template slot="dropdown" slot-scope="{closeDropdown}">
                <div class="dropdown">
                    <div class="tabs">
                        <div class="add-on-categories">
                            <div
                                    class="add-on-category"
                                    v-for="(addOnCategory, index) in addOnCategories"
                                    :class="{active: index === currentAddOnCategoryIndex}"
                                    @click="() => addOnCategoryOnClick(index)"
                                    :key="index"
                            >
                                {{ addOnCategory.name }}
                            </div>
                        </div>
                        <i class="fas fa-sort-up fa-3x close-btn" @click="closeDropdown"></i>
                    </div>
                    <div class="add-ons-container">
                        <perfect-scrollbar-container>
                            <div class="add-ons">
                                <div
                                    class="add-on"
                                    v-for="addOn in currentAddOnSet"
                                >
                                    <div class="basic-info">
                                        <img :src="addOn.photo_filepath" alt="">
                                        <div>{{ addOn.name }}</div>
                                        <div>
                                            {{ priceToString(addOn.price) }}
                                            <a href="" class="intro-trigger" @click.prevent="introTriggerOnClick(addOn.id)">{{ $t('addOnsSelect.intro')}}</a>
                                        </div>
                                    </div>
                                    <div>
                                        <span class="qty">
                                            <span class="btn-outline-black" @click="() => subtractQty(addOn.id) && closeDropdown()">-</span>
                                            {{ getQtyByAddOnId(addOn.id) }}
                                            <span class="btn-outline-black" @click="() => addQty(addOn.id) && closeDropdown()">+</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </perfect-scrollbar-container>

                    </div>
                </div>
            </template>
        </box-dropdown>
        <div class="popup" id="add-on-select-popup">
            <div class="popup-background">
                <div class="popup-body">
                    <div class="content">
                        <div class="add-on-category-select-container">
                            <add-on-category-select
                                    :add-on-categories="addOnCategories"
                                    :current-add-on-category-index="currentAddOnCategoryIndex"
                                    v-on:update:current-add-on-category-index="currentAddOnCategoryIndex = $event"
                            ></add-on-category-select>
                        </div>
                        <div class="add-ons-container">
                            <perfect-scrollbar-container>
                                <div class="add-ons">
                                    <div
                                        class="add-on"
                                        v-for="addOn in currentAddOnSet"
                                    >
                                        <div class="basic-info">
                                            <img :src="addOn.photo_filepath" alt="">
                                            <div>{{ addOn.name }}</div>
                                            <div>
                                                {{ priceToString(addOn.price) }}
                                                <a href="" class="intro-trigger" @click.prevent="introTriggerOnClick(addOn.id)">{{ $t('addOnsSelect.intro')}}</a>
                                            </div>
                                        </div>
                                        <div>
                                        <span class="qty">
                                            <span class="btn-outline-black" @click="() => subtractQty(addOn.id) && closeDropdown()">-</span>
                                            {{ getQtyByAddOnId(addOn.id) }}
                                            <span class="btn-outline-black" @click="() => addQty(addOn.id) && closeDropdown()">+</span>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </perfect-scrollbar-container>

                        </div>
                    </div>
                    <div class="close-btn">X</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BoxDropdown from '../BoxDropdown';
    import PerfectScrollbarContainer from '../PerfectScrollbarContainer';
    import AddOnCategorySelect from './AddOnCategorySelect';
    import Popup from '../../Popup';

    export default {
        props: [
            'addOns',
            'selectedAddOns'
        ],
        components: {
            BoxDropdown,
            PerfectScrollbarContainer,
            AddOnCategorySelect
        },
        data () {
            return {
                currentAddOnCategoryIndex: 0,
                popupInstance: null,
                isOpen: false,
                noClosingElSelector: [
                    '#product-details-popup',
                    '#add-on-select-popup .content'
                ]
            }
        },
        computed: {
            selectedItems() {
                return 'abc'
            },
            addOnCategories() {
                return this.$props.addOns.map(({id, name}) => ({id, name}))
            },
            currentAddOnSet() {
                return this.addOns[this.currentAddOnCategoryIndex].add_ons
            },
            flattenAddOns() {
                return this.addOns.map(item => item.add_ons).reduce((acc, val) => acc.concat(val));
            }
        },
        watch: {
            isOpen(newValue) {
                newValue ? this.popupInstance.openPopup() : this.popupInstance.closePopup();
            }
        },
        methods: {
            priceToString(price) {
                let _price = Number.parseFloat(price);
                _price = isNaN(_price) ? 0 : _price;
                return `$${ _price.toFixed(2)}`
            },
            introTriggerOnClick(addOnId) {
                const popup = window.popups.productDetailsPopup;
                const addOn = this.getAddOn(addOnId);
                popup.openPopup();
                popup.popup.find('.content').html(addOn.details);
            },
            addOnCategoryOnClick(index) {
                this.currentAddOnCategoryIndex = index;
            },
            getAddOn(addOnId) {
                const addOn = this.flattenAddOns.find(item => item.id === addOnId);
                return addOn === undefined ? null : addOn;
            },
            getQtyByAddOnId(addOnId) {
                const addOn = this.selectedAddOns.find(item => item.add_on_id === addOnId);
                return addOn !== undefined ? addOn.qty : 0;
            },
            subtractQty(addOnId) {
                const newQty = this.getQtyByAddOnId(addOnId) - 1;
                if(newQty >= 0) {
                    this.$emit('update-selected-add-on-qty', addOnId, newQty);
                }
            },
            addQty(addOnId) {
                const newQty = this.getQtyByAddOnId(addOnId) + 1;
                if(newQty <= 10) {
                    this.$emit('update-selected-add-on-qty', addOnId, newQty);
                }
            },
            removeAddOn(addOnId) {
                this.$emit('update-selected-add-on-qty', addOnId, 0);
            },
            updateIsOpen(isOpen) {
                this.isOpen = isOpen;
            }
        },
        mounted() {
            this.popupInstance = new Popup($('#add-on-select-popup'))
        }
    }
</script>

<style lang="stylus" type="text/stylus" scoped>
    .selected-items
        padding: 5px 10px
        max-width: 100%
        min-width: 0
        font-size: 0.8em
    .selected-item
        max-width: 100%
        display: flex
        align-items: center
        .name
            min-width: 0
            text-overflow: ellipsis
            white-space: nowrap
            overflow: hidden
        .remove-btn
            border-radius: 50%
            border: 1px solid #000
            width: 20px
            height: 20px
            display inline-flex
            align-items: center
            justify-content: center
            margin: 0 5px
            min-width: 20px
            &:hover
                opacity: 0.7

    $border-color = #000
    $border-width = 2px
    .dropdown
        display: flex
        flex-direction: column
        position: relative
        padding: 50px 10px 10px 10px
        width: 600px
        @media (max-width: 840px)
            display: none
        .tabs
            position: absolute
            top: 0
            left: 10px
            right: 10px
            display: flex
            justify-content: space-between
            .close-btn
                maring-top: 10px
                cursor: pointer
                &:hover
                    opacity: 0.7
        .add-on-categories
            max-width: 100%
            overflow: auto
            white-space: nowrap
            min-witdth: 0
            .add-on-category
                padding: 0 15px
                height: 52px
                display: inline-flex
                align-items: center
                justify-content: center
                cursor: pointer
                white-space: nowrap
                &.active
                    border-style: solid
                    border-color: $border-color
                    border-width: $border-width
                    border-bottom-color: #fff
    .add-ons-container
        flex: 2 1
        padding: 10px 0
        border: $border-width solid $border-color
        .add-ons
            display: flex
            flex-wrap: wrap
            align-items: stretch
            max-height: 300px
            padding-right: 30px
        .add-on
            display: inline-flex
            flex-direction: column
            justify-content space-between
            text-align: center
            width: 33%
            font-size: 0.9em
            line-height: 150%
            padding: 10px
            .add-on-img
                max-width: 120px
                width: 100%
            .intro-trigger
                font-size: 0.7em
                color: #313131
                &:hover
                    opacity 0.7
            .qty
                maring-top: 5px
            .btn-outline-black
                border: 2px solid #000
                display inline-flex
                align-items: center
                justify-content: center
                height: 20px
                width: 20px
                cursor: pointer
                user-select: none
                &:hover
                    opacity: 0.7
    #add-on-select-popup
        display: none
        .popup-body
            width: 90%
        @media (max-width: 840px)
            display: block
        .add-on-category-select-container
            padding: 10px
        .add-ons-container
            border: $border-width solid $border-color
            .add-ons
                height: unset
                max-height: 85vh
            .add-on
                width: 50%
</style>